import countryIsoMap from './mapping';

export function getFlagIconUrl(country: string): string | undefined {
    // Case insensitive check for country name in the mapping
    const countryKey = Object.keys(countryIsoMap).find(key => key.toLowerCase() === country.toLowerCase());
    if (countryKey) {
        const isoCode = countryIsoMap[countryKey];
        return `https://flagcdn.com/w20/${isoCode.toLowerCase()}.png`;
    }
    // If no match is found, return a default or empty URL
    return undefined;
}
